import React from 'react';
import { palettes } from '@indigo-ag/component-module';

import { createStylesHook } from 'shared/hooks/createStylesHook';

export interface StepDividerProps {
  longer?: boolean;
  completed: boolean;
}

const useStyles = createStylesHook({
  verticalLineContainer: {
    '& span': {
      width: 1,
      backgroundColor: palettes.neutral[700]
    },
    '&.longer': {
      minHeight: 65
    },
    '&.completed span': {
      minHeight: 65,
      backgroundColor: palettes.coastal.accent.green
    },
    display: 'flex',
    justifyContent: 'center',
    minHeight: 56,
    width: 65
  }
});

export const StepDivider: React.FunctionComponent<StepDividerProps> = ({ longer = false, completed }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const dividerClasses = `${classes.verticalLineContainer} ${longer ? 'longer' : ''} ${completed ? 'completed' : ''}`;
  return (
    <div className={dividerClasses}>
      <span />
    </div>
  );
};
